<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-form v-model="formValid">
        <slot />
      </v-form>
    </v-flex>
  </v-layout>

</template>

<script>
import ActionBase from '@/components/ActionBase'

export default {
  name: 'input-form',
  extends: ActionBase,
  props: {
    title: {
      type: String,
      require: false,
      default: ''
    },
    deletable: {
      type: Boolean,
      require: false,
      default: false
    },
    printable: {
      type: Boolean,
      require: false,
      default: false
    },
    refreshable: {
      type: Boolean,
      require: false,
      default: false
    },
    historyable: {
      type: Boolean,
      require: false,
      default: true
    },
    approveH: {
      type: Boolean,
      require: false,
      default: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    approval: {
      type: Boolean,
      required: false,
      default: true
    },
    cancelable: {
      type: Boolean,
      required: false,
      default: false
    },
    attachable: {
      type: Boolean,
      required: false,
      default: false
    },
    havefile: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      formValid: false,
      actions: [
        { tooltip: 'Close', icon: 'exit_to_app', handler: this.close, render: this.approval, color: 'info' },
        { tooltip: 'Refresh', icon: 'refresh', handler: this.refresh, render: this.refreshable && this.approval },
        { tooltip: 'Save', icon: 'save', handler: this.save, color: 'success', disabled: true, render: this.editable && this.approval },
        { tooltip: 'Cancel', icon: 'cancel', handler: this.cancel, render: this.cancelable },
        { tooltip: 'Delete', icon: 'delete', handler: this._delete, render: this.deletable && this.editable && this.approval, color: 'error' },
        { tooltip: 'Print', icon: 'print', handler: this.print, render: this.printable && this.approval, color: 'error' },
        { tooltip: 'Show Document History', icon: 'history', handler: this.showHistory, render: this.historyable && this.approval, color: 'error' },
        { tooltip: 'Show Approval History', icon: 'assignment_turned_in', handler: this.showApproveH, render: this.approveH && this.approval, color: 'error' },
        { tooltip: 'Approve', icon: 'check_circle', handler: this.showApprovalD, render: !this.approval, color: 'success' },
        { tooltip: 'Delete', icon: 'delete', handler: this.deleteFile, render: this.attachable, color: 'error', type: 'Download' },
        { tooltip: 'Download', icon: 'archive', handler: this.download, render: this.attachable, color: 'success', type: 'Download' },
        { tooltip: 'Upload', icon: 'attach_file', handler: this.upload, render: this.attachable, color: 'info', type: 'Download' }
      ]
    }
  },
  watch: {
    formValid: function (oldValue, newValue) {
      this.actions.find(x => x.handler === this.save).disabled = newValue
      this.registerActions()
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    save () {
      this.$emit('save')
    },
    _delete () {
      this.$emit('delete')
    },
    print () {
      this.$emit('print')
    },
    refresh () {
      this.$emit('refresh')
    },
    change () {
      this.$emit('change')
    },
    upload () {
      this.$emit('upload')
    },
    download () {
      this.$emit('download')
    },
    deleteFile () {
      this.$emit('deleteFile')
    },
    showHistory () {
      this.$showHistory({vueinstance: this, Id: this.$route.params.id, Status: true})
    },
    showApproveH () {
      this.$showApproveH({vueinstance: this, Id: this.$route.params.id, Status: true})
    },
    showApprovalD () {
      this.$showApprovalStatus({vueinstance: this, status: true})
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/InputForm.vue